import { Injectable } from '@angular/core';
import { loadUser, loadUserFailure, loadUserSuccess } from './user.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { UsersService } from './users.service';


@Injectable()
export class UserEffects {
  constructor(private actions$: Actions, private userService: UsersService) {}

  loadUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUser),
      switchMap(() =>
        this.userService.getMe().pipe(
          map(({ data }) => loadUserSuccess({ user: data })),
          catchError((error) => of(loadUserFailure({ error })))
        )
      )
    )
  );
}
